import { message } from "antd";
import jsPDF from "jspdf";
import "jspdf-autotable";

const ExportPDF = (tableData, tableColumns, title) => {
  if (tableData.length === 0) {
    message.error("No data found to export!");
    return;
  }
  const doc = new jsPDF();
  doc.text(title, 20, 10);
  const tableColumn = tableColumns.map((col) => col.title);
  const tableRows = tableData.map((data) =>
    tableColumns.map((col) => data[col.dataIndex])
  );
  doc.autoTable({
    head: [tableColumn],
    body: tableRows,
  });
  doc.save(`${title}.pdf`);
};

export default ExportPDF;
